import type { StateCreator } from 'zustand';
import type { CanvasState } from './types';
import { bumpStructureVersion, debugLog } from './utils';

type StoreSet = Parameters<StateCreator<CanvasState>>[0];
type StoreGet = Parameters<StateCreator<CanvasState>>[1];

export type SliceCtx = ReturnType<typeof createCtx>;

export function createCtx(_set: StoreSet, get: StoreGet) {
  const inflightLLM = new Set<string>();

  let inferTimer: ReturnType<typeof setTimeout> | null = null;
  const INFER_DEBOUNCE_MS = 160;

  const queueInference = (opts?: { immediate?: boolean }) => {
    if (opts?.immediate) {
      if (inferTimer) {
        clearTimeout(inferTimer);
        inferTimer = null;
      }
      try {
        get().inferAndApplyPinTypes();
      } catch {
        /* noop */
      }
      return;
    }
    if (inferTimer) clearTimeout(inferTimer);
    inferTimer = setTimeout(() => {
      inferTimer = null;
      try {
        get().inferAndApplyPinTypes();
      } catch {
        /* noop */
      }
    }, INFER_DEBOUNCE_MS);
  };

  return {
    inflightLLM,
    queueInference,
    cancelQueuedInference: () => {
      if (inferTimer) {
        clearTimeout(inferTimer);
        inferTimer = null;
      }
    },
    bumpStructureVersion,
    debugLog,
  };
}
